var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uniform-filters" },
    [
      !_vm.inited
        ? _c("c-loader", {
            attrs: {
              active: _vm.inited,
              label: "Инициализация фильтров",
              height: 300,
            },
          })
        : _c(
            "div",
            [
              _c("transition", { attrs: { name: "slide" } }, [
                _vm.open
                  ? _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col col-12" }, [
                        _c(
                          "div",
                          { staticClass: "form-group uniform-filters__status" },
                          [
                            _c("c-switcher", {
                              staticClass: "h-switcher",
                              attrs: { type: "group", items: _vm.states },
                              on: { input: _vm.onUpdateState },
                              model: {
                                value: _vm.form.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "state", $$v)
                                },
                                expression: "form.state",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "col col-12" }, [
                        _c(
                          "div",
                          {
                            staticClass: "form-group uniform-filters__category",
                          },
                          [
                            _c("c-input", {
                              attrs: {
                                type: "select",
                                multiple: true,
                                items: _vm.catalog,
                                searchable: true,
                                "with-categorized": true,
                                "disabled-values": _vm.disabledCatalogItems,
                                label: "Категория/подкатегория/тип ТМЦ",
                                placeholder: "Все",
                                "checkbox-value": _vm.form.categoriesExclude,
                                checkbox: true,
                                "checkbox-type": "icon",
                                "checkbox-tooltip": {
                                  disabledText:
                                    "Фильтр по всем значениям в справочнике, кроме выбранных",
                                  activeText:
                                    "Выключить фильтр по всем значениям в справочнике, кроме выбранных",
                                  notActiveText:
                                    "Включить фильтр по всем значениям в справочнике, кроме выбранных",
                                },
                              },
                              on: {
                                checkboxChange: function ($event) {
                                  _vm.form.categoriesExclude = $event
                                },
                              },
                              model: {
                                value: _vm.form.categories,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "categories", $$v)
                                },
                                expression: "form.categories",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "col col-12 col-md-4 col-xl-4" },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group uniform-filters__name" },
                            [
                              _c("c-input", {
                                attrs: {
                                  clearable: true,
                                  label: "Серийный номер/наименование ТМЦ",
                                  placeholder: "Любое",
                                },
                                on: { enter: _vm.apply },
                                model: {
                                  value: _vm.form.nameAndNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "nameAndNumber", $$v)
                                  },
                                  expression: "form.nameAndNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "col col-12 col-md-4 col-xl-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-group uniform-filters__workers",
                            },
                            [
                              _c("c-input", {
                                attrs: {
                                  type: "select",
                                  items: _vm.workers,
                                  searchable: true,
                                  multiple: true,
                                  label: "Сотрудник, которому выдана ТМЦ",
                                  placeholder: "Все",
                                },
                                model: {
                                  value: _vm.form.workers,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "workers", $$v)
                                  },
                                  expression: "form.workers",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "col col-12 col-md-4 col-xl-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "form-group uniform-filters__status",
                            },
                            [
                              _c("c-input", {
                                attrs: {
                                  type: "select",
                                  items: _vm.statuses,
                                  clearable: true,
                                  label: "Статус ТМЦ",
                                  placeholder: "Все",
                                },
                                model: {
                                  value: _vm.form.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "status", $$v)
                                  },
                                  expression: "form.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "col col-12 col-md-4 col-xl-4" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-group uniform-filters__expiration",
                            },
                            [
                              _c("c-input", {
                                attrs: {
                                  type: "select",
                                  items: _vm.expirationTypes,
                                  clearable: true,
                                  label: "По сроку годности ТМЦ",
                                  placeholder: "Любой",
                                },
                                model: {
                                  value: _vm.form.expiration,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "expiration", $$v)
                                  },
                                  expression: "form.expiration",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.expirationDaysFilter
                        ? _c(
                            "div",
                            { staticClass: "col col-12 col-md-4 col-xl-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group uniform-filters__exp-days",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "d-flex" },
                                    [
                                      _c("c-input", {
                                        attrs: {
                                          clearable: true,
                                          type: "price-number",
                                          required:
                                            _vm.isSubmitted &&
                                            _vm.expirationDaysError,
                                          "required-message":
                                            _vm.isSubmitted &&
                                            _vm.expirationDaysError,
                                          "required-condition":
                                            _vm.isSubmitted &&
                                            _vm.expirationDaysError,
                                        },
                                        model: {
                                          value: _vm.form.expirationDays,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "expirationDays",
                                              $$v
                                            )
                                          },
                                          expression: "form.expirationDays",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "uniform-filters__label",
                                        },
                                        [_vm._v("дней")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.expirationPeriodFilter
                        ? _c(
                            "div",
                            {
                              staticClass: "col col-12 col-md-4 col-xl-3",
                              class: {
                                "is-invalid": _vm.expirationDaysError,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "form-group uniform-filters__exp-period",
                                },
                                [
                                  _c("c-input", {
                                    ref: "expirationPeriod",
                                    attrs: {
                                      label: "Период истечения срока",
                                      placeholder: "Выберите период",
                                      type: "period-without-fixed-intervals",
                                      icon: "calendar",
                                      "icon-right": true,
                                    },
                                    on: {
                                      mounted: _vm.onExpirationPeriodMounted,
                                    },
                                    model: {
                                      value: _vm.form.expirationPeriod,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "expirationPeriod",
                                          $$v
                                        )
                                      },
                                      expression: "form.expirationPeriod",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "uniform-filters__actions" },
                        [
                          _c("c-button", {
                            staticClass: "uniform-filters__reset",
                            attrs: { label: "Сбросить" },
                            on: { click: _vm.reset },
                          }),
                          _c("c-button", {
                            staticClass: "uniform-filters__apply",
                            attrs: { label: "Применить", color: "primary" },
                            on: { click: _vm.apply },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
              !_vm.isDesktop
                ? [
                    _vm.open
                      ? _c("c-button", {
                          staticClass: "uniform-filters__toggler",
                          attrs: { size: "small", label: "Скрыть фильтры" },
                          on: {
                            click: function ($event) {
                              _vm.open = false
                            },
                          },
                        })
                      : _vm._e(),
                    !_vm.open
                      ? _c("c-button", {
                          staticClass: "uniform-filters__toggler",
                          attrs: { size: "small", label: "Показать фильтры" },
                          on: {
                            click: function ($event) {
                              _vm.open = true
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }